import React, { useState } from "react";
import { Spin, Row, Col, notification, Form } from "antd";
import CropDown from "../../components/ReportFormGenerator/CropDown/CropDown";
import Button from "../../components/ReportFormGenerator/Button/Button";
import Idame from "../../components/ReportFormGenerator/Idame/Idame";
 import StablePrime from "../../components/Tables/StablePrime";

function TrainingDojo({ setPageHeader }) {
  const [form] = Form.useForm();
  const [FormData, setFormData] = useState(null);
  setPageHeader("Training Dojo");

  const onFinish = (values) => {
    setFormData(values);
    
  };

  const productionTableStyle = {
    marginTop: "1rem",
    marginBottom: "1rem",
  };

  const Tables = () => {
    if (FormData) {
      return (
        <>
          {FormData ? (
            <div style={productionTableStyle}>
              <StablePrime
                url="/"
                data={FormData}
                identity="Training Dojo"
              />
            </div>
          ) : (
            <></>
          )}
        </>
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row justify="center">
              <Col span={12}>
                <Idame
                  // width = {100}
                  form={form}
                  type="name"
                  url="/mdict"
                  urlData={{
                    typ: "Employee",
                    subTyp: "idame",
                    includeAll: true,
                  }}
                  idName="eid"
                  idLabel="Employee Id"
                  idErrorMessage="Please Select Employee Id"
                  idRequired={true}
                  idPlaceholder="Select Employee Id"
                  nameName="eame"
                  nameLabel="Employee Name"
                  nameErrorMessage="Please Select Employee Name"
                  nameRequired={true}
                  namePlaceholder="Select Employee Name"
                  defaultIdValue="All"
                  defaultNameValue="All"
                />
              </Col>
            </Row>

            <Row gutter={24} justify="center">
              <Col span={24}>
                <Button
                  marginLeft={"300px"}
                  form={form}
                  cancelButtonText={"Cancel"}
                  submitButtonText={"Submit"}
                  resetButton={true}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <Tables />
    </>
  );
}

export default TrainingDojo;
